import styled from 'styled-components';

export const PageContentTabs = styled.div`
  {
    .ant-tabs-tab {
      padding: 0 8px 4px;
      .ant-tabs-tab-btn {
        color: #335777;
      }
    }
    .ant-tabs-ink-bar {
      background: #335777;
    }
    .ant-tabs-nav-wrap {
      border: 2px solid #d2cfcf;
      border-width: 0 0 1px 0;
    }
  }
 `;

 export const TabContainer = styled.div`
.ant-tabs-top > .ant-tabs-nav {
  margin: 0px;
  background-color: rgba(255, 255, 255, 0.8);
  margin-top: 1px;
  &::before {
    border: none;
  }
}
.ant-tabs-nav-list {
  margin-left: 32px;
  margin-right: 8px;
}
.ant-tabs-tab {
  padding: 9px;
}
.ant-tabs-tabpane {
  padding: 30px;
}`;